<ng-container *ngIf="header && header.counters">
    <div class="counter" *ngFor="let counter of header.counters | sortBy:'order'" [ngClass]="counter.generalClass">
        <div class="prompt">{{counter.caption}}
            <i class="fa fa-lock only-lock" aria-hidden="true"></i>
        </div>
        <div class="value"> {{counter.value}}</div>
        <i class="fa fa-info only-lock" aria-hidden="true" *ngIf="counter.toolTip"><shared-copyclipboard
                [value]="counter.toolTip"></shared-copyclipboard></i>
    </div>
</ng-container>